import { render } from "./ModalButton.vue?vue&type=template&id=370160bf"
import script from "./ModalButton.vue?vue&type=script&lang=ts"
export * from "./ModalButton.vue?vue&type=script&lang=ts"

import "./ModalButton.vue?vue&type=style&index=0&id=370160bf&lang=scss"
script.render = render

export default script